export default function() {
  return new Worker(__webpack_public_path__ + "static/js/evaluation.worker.ba0a855a.worker.js");
}
